<template>
  <div>
    <b-container>
      <small><label>Επιλογή Ακαδημαϊκού Έτους</label></small>
      <b-row class="breakPoint">
        <b-col sm="10">
          <b-form-select v-model="selected" :options="options">
            <template slot="first">
              <option :value="null" disabled>-- Παρακαλώ επιλέξτε έτος --</option>
            </template>
          </b-form-select>
        </b-col>
        <b-button
            size="sm"
            variant="outline-info"
            @click="searchAvailability">Αναζήτηση
        </b-button>
      </b-row>
    </b-container>

    <div class="loading-parent">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"></loading>
    </div>

    <b-container fluid  v-show="searchEnable">
      <availability-list-component></availability-list-component>
    </b-container>

  </div>
</template>

<script>

  import requests from '../../js/DistributionRequestService';
  import Utils from '../../js/AppUtilities';
  import {GlobalEudoxusBus} from '../../js/DistributionRequestService';
  import AvailabilityListComponent from './AvailabilityListComponent';

  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';

  export default {
    data() {
      return {
        isLoading: false,
        fullPage: true,
        searchEnable: false,
        selected: null,
        downloading: false,
        options: [],
        tableMap: []
      }
    },
    components: {
      'loading': Loading,
      'availabilityListComponent': AvailabilityListComponent
    },
    methods: {
      searchAvailability() {
        this.isLoading = true;
        if (this.selected != null) {
          requests.getBooksAvailabilityForDistributionPoint(requests.getDistributionPointId(), this.selected, this.fillUpDataTable)
        } else {
          this.isLoading = false;
          alert("Παρακαλώ επιλέξτε Έτος");
        }
      },
      fillUpDataTable(resultArray) {
        this.tableMap = Utils.availabilityMapResolver(resultArray, this.selected);
        GlobalEudoxusBus.$emit('availabilityTableSetup', this.tableMap);
        this.searchEnable = true;
        this.isLoading = false;
      },
      selectOptions(object) {
        this.options = object;
      },
      setUpComponent() {
        this.searchEnable = false;
        requests.getAcademicYearsSelect("Availability", this.selectOptions);
      }
    },
    created() {
      GlobalEudoxusBus.$on('globalSetupEvent', globalSetupEvent => {
        if (globalSetupEvent)
          this.setUpComponent();
      });
    }
  }
</script>

<style scoped>

  .breakPoint {
    padding-bottom: 1em;
  }

  .loading-parent {
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/components/AvailabilityTabComponents/SearchAvailabilityComponent.vue